import axios from "axios";

const transApi= process.env.REACT_APP_API_TRANSACTION;
const currentUser = JSON.parse(sessionStorage.getItem("authUser"));

  // export const addBusiness = async (data) => {
  //     try {
  //       const response = axios.create(`/transactions/${data?.merchandId}`, data);
  //       return response;
  //     } catch (error) {
  //       throw error;
  //     }
  // };

  export const getTransactionBymerchandId = async (merchandId) => {
      try {
        const response =  axios.get(`${transApi}/transaction/pay-in/merchant/${merchandId}`, {
          headers: {
            Authorization: `Bearer ${currentUser?.token}`,
          }
        });
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const getAllTransactions = async () => {
      try { 
        const response =  axios.get(`${transApi}/transaction`, {
          headers: {
            Authorization: `Bearer ${currentUser?.token}`,
          }
        });
        return response;
      } catch (error) {
        throw error;
      }
  };

  export const deleteDeveloper = async (id) => {
    try {
        const response = await axios.delete(`/transactions/${id}`);
        return response;
    } catch (error) {
        throw error;
    }
  };
  
  export const validateBusiness = async ( accountId, data) => {
    try {
      const response = await axios.put(`/transactions/activate/${accountId}`, data);
      return response;
    } catch (error) {
      throw error;
    }
  };
  
  export const desactiveBusiness = async ( accountId, data) => {
    try {
      const response = await axios.put(`/transactions/deactivate/${accountId}`, data);
      return response;
    } catch (error) {
      throw error;
    }
  };

  export const getCompanyByCompanyId = async (companyId) => {
    try {
      const response = await axios.get(`/transactions/company/${companyId}`);
      return response;
    } catch (error) {
      throw error;
    }
  };

  export const makeProdDeveloper = async (developerId) => {
    try {
      const response = await axios.put(`/transactions/${developerId}/switch-to-production`);
      return response;
    } catch (error) {
      throw error;
    }
  };

  export const addSector = async (name) => {
    try {
      const response = await axios.create(`/sector/create`, {name});
      return response;
    } catch (error) {
      throw error;
    }
  };

  export const getAllSector = async () => {
    try {
      const response = await axios.get(`/sector/all`);
      return response;
    } catch (error) {
      throw error;
    }
  };

  export const getTurnOverByBusinessId = async (busId, year) => {
    try {
      const response = await axios.get(`/transactions/${busId}/revenues/${year}`);
      return response;
    } catch (error) {
      throw error;
    }
  };

  export const getMetricsByBusIdPercountryCode = async (busId, cc) => {
    try {
      const response = await axios.get(`/transactions/${busId}/country-balance/${cc}`);
      return response;
    } catch (error) {
      throw error;
    }
  };

  export const getAnnualTransfertByBusinessId = async (busId, year) => {
    try {
      const response = await axios.get(`/transactions/${busId}/transfers/${year}`);
      return response;
    } catch (error) {
      throw error;
    }
  };

  export const getTransStatByBusId = async (busId, month, year) => {
    try {
      const response = await axios.get(`/transactions/${busId}/transactionStats?month=${month}&year=${year}`);
      return response;
    } catch (error) {
      throw error;
    }
  };

  export const getMetricsByBusIdPerOperator = async (busId) => {
    try {
      const response = await axios.get(`/transactions/${busId}/transaction-category-count`);
      return response;
    } catch (error) {
      throw error;
    }
  };

export const getTransctionByBusinessId = async (business) => {
  try {
    const token = JSON.parse(sessionStorage.getItem("authAdmin"))?.token;

    const response = await axios.get(
      `${process.env.REACT_APP_API_TRANSACTION}/manage/pay-in/business`,
      {
        params: {
          business: business,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("🔴 API ERROR:", error?.response?.data || error);
    throw error;
  }
};

export const getBusinessVolumeTransactions  = async () => {
  try {
    const token = JSON.parse(sessionStorage.getItem("authAdmin"))?.token;

    const response = await axios.get(
     `${process.env.REACT_APP_API_TRANSACTION}/kpi/top-transaction-volume`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response;
  } catch (error) {
    console.error("🔴 API ERROR:", error?.response?.data || error);
    throw error;
  }
};
export const getTopTransactions  = async () => {
  try {
    const token = JSON.parse(sessionStorage.getItem("authAdmin"))?.token;
    const response = await axios.get(
     `${process.env.REACT_APP_API_TRANSACTION}/kpi/top-transaction`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response;
  } catch (error) {
    console.error("🔴 API ERROR:", error?.response?.data || error);
    throw error;
  }
};
export const getManagePayIn  = async () => {
  try {
    const token = JSON.parse(sessionStorage.getItem("authAdmin"))?.token;
    const response = await axios.get(
     `${process.env.REACT_APP_API_TRANSACTION}/manage/pay-in`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response;
  } catch (error) {
    console.error("🔴 API ERROR:", error?.response?.data || error);
    throw error;
  }
};